import { AppHeroSwitch, SwitchThumb } from '../HeroSwitch'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { HeroIcon } from '../HeroIcon'

interface IAutoPlaySwitchProps {
  isActive: boolean
  icon: IconProp
  onPress: () => void
}

export function AutoPlaySwitch({
  isActive = false,
  icon,
  onPress,
}: IAutoPlaySwitchProps) {
  return (
    <AppHeroSwitch
      defaultChecked={isActive}
      active={isActive}
      onPress={onPress}
      height={11}
      width={31}
      backgroundColor={isActive ? '$cross-300' : '#6E6E6E'}
      borderColor={isActive ? '$cross-300' : '#6E6E6E'}
    >
      <SwitchThumb
        width={16}
        height={16}
        animation="medium"
        top={-5}
        left={isActive ? 6 : -6}
        right={-6}
        backgroundColor={isActive ? '$cross-100' : '$cross-400'}
      >
        <HeroIcon
          icon={icon}
          size={6}
          color={isActive ? '$cross-500' : '$cross-100'}
        />
      </SwitchThumb>
    </AppHeroSwitch>
  )
}
